'use client';

import Image from 'next/image';
import { useRouter } from 'next/navigation';
import ROUTES from '@/lib/constants/routeConfig';
import { useI18n } from '@/locales/client';

export default function NotFound() {
  const router = useRouter();
  const t = useI18n();
  
  return (
    <div className='flex min-h-dvh items-center justify-center px-4 py-8'>
      <div
        className={`flex w-full max-w-md flex-col items-center rounded-xl border border-gray-200 bg-white/90 p-8 shadow-lg dark:border-gray-700 dark:bg-gray-900/80`}
      >
        {/* Animated logo with JAQLN text */}
        <div className='mb-6 flex flex-col items-center'>
          <div className='mb-2 flex flex-row items-center'>
          <div className='relative h-20 w-20'>
              <Image
                src='/images/JAQLNLogo.png'
                alt='Jaqln Logo'
                fill
                priority
                sizes='80px'
                style={{ objectFit: 'cover' }}
              />
            </div>
            <span className='mr-3 select-none text-2xl font-extrabold tracking-wide text-[#9147ff] dark:text-purple-400'>
              JAQLN
            </span>

          </div>
        </div>
        {/* 404 Message */}
        <h1 className='mb-2 text-center text-2xl font-bold text-gray-900 dark:text-white'>
          {t('error.legal404Title')}
        </h1>
        <p className='mb-6 text-center text-gray-600 dark:text-gray-300'>
          {t('error.legal404Message')}
        </p>
        {/* Navigation button */}
        <button
          className='w-full rounded-md bg-[#9147ff] px-4 py-2 font-semibold text-white shadow transition-colors hover:bg-[#7a36d4]'
          onClick={() => router.push(ROUTES.HOME)}
          aria-label='Go to homepage'
        >
          {t('error.goHome')}
        </button>
      </div>
      <style jsx global>{`
        @keyframes spin-slow {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
        .animate-spin-slow {
          animation: spin-slow 2.5s linear infinite;
        }
      `}</style>
    </div>
  );
}
